<template>
  <div class="plateorder">
    <div class="plateorder-tabs vue_flex vue_flex_between vue_align_center">
      <div class="plateorder-tabs-input vue_flex vue_align_center">
        <div class="top_bar_inp vue_flex vue_align_center">
          <img class="top_bar_inp_img1 h" src="../../../../../assets/yimou/ss.png" alt="" />
          <input type="text" class="top_bar_inp_inp" v-model="searchValue" placeholder="搜索用户昵称/登录账号/手机号" />
        </div>
        <div class="shaixuan_item vue_flex vue_flex_between vue_align_center h">
          <div class="shaixuan_item_con vue_flex vue_align_center">
            <img class="shaixuan_item_icon" src="../../../../../assets/ym/tjsj@2x.png" alt=""/>
            <div class="shaixuan_item_tit">账号状态</div>
          </div>
          <el-select v-model="searchValue" placeholder="账号状态" class="vue_flex_item">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="vue_flex vue_align_center">
        <div class="plateorder-tabs-piye-but vue-font-PingFang-500 color_35 h">企业管理</div>
        <div class="plateorder-tabs-input-but vue-font-PingFang-500 color_255 h" @click="strokeDrawer = true">添加子账号</div>
      </div>
    </div>

    <div class="width_100" style="margin-top: 28px;">
      <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" @selection-change="handleSelectionChange" border height="70vh" :key="'taobaoTable'">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="account" label="登录账号" align="center"></el-table-column>
        <el-table-column prop="phone" label="绑定手机号" align="center"></el-table-column>
        <el-table-column prop="nickname" label="用户昵称" align="center"></el-table-column>
        <el-table-column prop="roles_name" label="角色" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isadmin === '1'">主账号</el-tag>
            {{scope.row.roles_name || ''}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="账号状态" align="center" >
          <template slot-scope="scope">
            <div class="vue_flex vue_flex_around">
              <div class="vue_flex vue_align_center">
                <div :class="scope.row.accountstatus === '1'? 'statusactnot' : 'statusact'"></div>
                <span>{{scope.row.accountstatus === '1'? '禁止' : '正常'}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-dropdown>
              <el-button type="text" class="reset-btn vue-font-PingFang-bold">...</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item type="success" size="mini">
                  <el-button type="text" @click="exportExcel(scope.row, 1)">编辑用户昵称</el-button>
                </el-dropdown-item>
                <div class="dropdown-solid"></div>
                <el-dropdown-item type="success" size="mini">
                  <el-button type="text" @click="exportExcel(scope.row, 2)">重置密码</el-button>
                </el-dropdown-item>
                <div class="dropdown-solid"></div>
                <el-dropdown-item type="success" size="mini">
                  <el-button type="text" @click="exportExcel(scope.row, 3)">变更角色</el-button>
                </el-dropdown-item>
                <div class="dropdown-solid"></div>
                <el-dropdown-item type="success" size="mini">
                  <el-button type="text" @click="exportExcel(scope.row, 4)">冻结\解冻</el-button>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getindexUserFun"/>



    <el-drawer title="添加子账号" @close="editorClose('child')" :visible.sync="strokeDrawer" :show-close="true" size="34%">
      <div ref="scrollContainer" style="max-height: 88vh; overflow-y: auto;">
        <div class="revenbook-drawer vue_flex vue_column">
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 登录账号 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-input v-model="tempObj.account" placeholder="请输入账号" class="vue-font-PingFang-500"></el-input>
              </div>
            </li>
            <li class="vue-font-PingFang-500 color_153" style="font-size: 14px; line-height: 14px; margin-top: 13px;">仅支持中文、英文字母小写、数字、下划线，不能超过16位字符</li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 手机号 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-input v-model="tempObj.phone" type="number" placeholder="请输入手机号" class="vue-font-PingFang-500"></el-input>
              </div>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 密码 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-input v-model="tempObj.password" placeholder="请输入密码，不少于6位数" class="vue-font-PingFang-500"></el-input>
              </div>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 确认密码 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-input v-model="tempObj.againpass" placeholder="请再次输入密码" class="vue-font-PingFang-500"></el-input>
              </div>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <span>*</span>
              <p> 用户昵称 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-input v-model="tempObj.nickname" placeholder="请输入用户名" class="vue-font-PingFang-500"></el-input>
              </div>
            </li>
            <li class="vue-font-PingFang-500 color_153" style="font-size: 14px; line-height: 14px; margin-top: 13px;">仅支持中文、英文字母小写、数字、下划线，不能超过16位字符</li>
          </ul>

          <ul class="revenbook-drawer-ul vue_flex vue_column">
            <li class="vue_flex vue-font-PingFang-500">
              <p> 角色 </p>
            </li>
            <li class="revenbook-drawer-ul-view vue_flex vue_align_center">
              <div class="revenbook-drawer-ul-boxs vue_flex_item">
                <el-select v-model="tempObj.roles" multiple placeholder="请选择">
                  <el-option v-for="item in personList" :key="item.id" :label="item.roles" :value="item.id"></el-option>
                </el-select>
              </div>
            </li>
          </ul>
          <ul class="revenbook-drawer-ul vue_flex vue_flex_end">
            <div class="revenbook-drawer-ul-but vue-font-PingFang-500 color_255 h" @click="childaccountClick">确定</div>
          </ul>

        </div>
      </div>
    </el-drawer>


    <el-dialog @close="editorClose('person')" :visible.sync="dialogVisible" title="编辑人员" width="25vw" >
      <el-form :model="editorObj" label-width="80px" label-position="left">
        <el-form-item label="用户名称" v-if="Number(editorIndex) === 1">
          <el-input v-model="editorObj.nickname" placeholder="请输入用户名称" />
        </el-form-item>
        <el-form-item label="密码" v-if="Number(editorIndex) === 2">
          <el-input v-model="editorObj.password" placeholder="请输入账号" show-password/>
        </el-form-item>
        <el-form-item label="角色" v-if="Number(editorIndex) === 3">
          <el-select v-model="editorObj.roles_id" placeholder="请选择" @change="rolesChanges(editorObj)">
            <el-option v-for="item in personList" :key="item.id" :label="item.roles" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账号状态" v-if="Number(editorIndex) === 4">
          <el-radio-group v-model="editorObj.accountstatus">
            <el-radio label="0">禁止</el-radio>
            <el-radio label="1">正常</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button type="danger" @click="dialogVisible = false"> 取消 </el-button>
        <el-button type="primary" :loading="isButFlag" @click="pyyes"> 确认 </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
  components: { Pagination },
  data() {
    return {
      innerWidth: 0,
      innerHeight: 0,
      headercellstyle: {
        backgroundColor: 'rgba(245, 247, 250, 1)',
        color: 'rgba(51, 3, 0, 1)'
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
      },



      wenzi: '',
      searchValue: '',
      dataList: [],

      options: [{ value: '选项1', label: '黄金糕' }, { value: '选项2', label: '双皮奶' }, { value: '选项3', label: '蚵仔煎' }, { value: '选项4', label: '龙须面' }, { value: '选项5', label: '北京烤鸭' }],

      input: '',

      strokeDrawer: false,
      tempObj: {
        account: '',
        phone: '',
        password: '',
        againpass: '',
        nickname: '',

        roles: [],
        roles_name: [],
        shopid: '',
        shopname: '',
      },

      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
      },

      dialogVisible: false,
      editorObj: {
        touid: '',
        password: '',
        nickname: '',
        roles: '',
        roles_name: '',
        accountstatus: '',
      },
      editorIndex: '',
      isButFlag: false,
      personList: [],


    }
  },

  async created() {
    this.innerWidth = windowFun().innerWidth;
    this.innerHeight = windowFun().innerHeight;
    await this.ManagerRolesFun()
    await this.getindexUserFun()
  },

  methods: {
    async ManagerRolesFun(){
      const res = await this.$http.get(this.$urls.ManagerRoles);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.personList = res.data
    },

    rolesChanges(row){
      for(let item of this.personList){
        if(Number(item.id) === Number(row.roles_id)){
          row.roles = item.roles
        }
      }
    },

    editorClose(type){
      if(type === 'child'){
        Object.keys(this.tempObj).forEach(key =>{
          this.tempObj[key] = ""
        })
        this.$set(this.tempObj, 'roles', [])
        this.$set(this.tempObj, 'roles_name', [])
      }
      if(type === 'person'){
        Object.keys(this.editorObj).forEach(key =>{
          this.editorObj[key] = ""
        })
        this.editorIndex = ""
      }
    },

    exportExcel(row, index){
      console.log(index, '1010010')
      let editor = Object.assign({}, row)
      this.editorObj = editor
      this.$set(this.editorObj, 'touid', editor.id)
      this.editorIndex = index
      this.dialogVisible = true
    },

    pyyes(){
      this.changeindexuserFun()
    },

    handleSelectionChange(e){
      console.log(e,'9090909090')
    },

    async childaccountClick(){
      if (!this.tempObj.account) return DonMessage.error('请输入账号');
      if (!this.tempObj.phone) return DonMessage.error('请输入手机号');
      if (!this.tempObj.password) return DonMessage.error('请输入秘密');
      if (!this.tempObj.againpass) return DonMessage.error('请再次输入密码');
      if (this.tempObj.password !== this.tempObj.againpass) return DonMessage.error('密码验证错误');
      if (!this.tempObj.nickname) return DonMessage.error('请输入昵称');
      let roles_name = []
      if(this.tempObj.roles.length > 0){
        for(let item of this.personList){
          for(let val of this.tempObj.roles){
            if(Number(val) === Number(item.id)){
              roles_name.push(item.roles)
            }
          }
        }
      }

      const res = await this.$http.post(this.$urls.createuser, {
        ...this.tempObj,
        roles: this.tempObj.roles.length > 0? this.tempObj.roles.join(",") : '',
        roles_name: roles_name.length > 0? roles_name.join(",") : '',
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      DonMessage.success("操作成功");
      this.strokeDrawer = false
      this.getindexUserFun()
    },

    async getindexUserFun(){
      const res = await this.$http.get(this.$urls.getindexUserList, this.listQuery);
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      this.total = res.data.count
      this.dataList = res.data.list
    },

    async changeindexuserFun(){
      let password, nickname, roles, roles_name
      switch(Number(this.editorIndex)){
        case 1:
          nickname = this.editorObj.nickname
          break;
        case 2:
          password = this.editorObj.password
          break;
        case 3:
          roles = this.editorObj.roles_id
          roles_name = this.editorObj.roles
          break;
      }
      const res = await this.$http.post(this.$urls.changeindexuser, {
        touid: this.editorObj.touid,
        password: password,
        nickname: nickname,
        roles: roles,
        roles_name: roles_name,
        accountstatus: this.editorObj.accountstatus,
      });
      if (res.errcode != 0) return DonMessage.error(res.errmsg);
      console.log(res,'9090909090')
      DonMessage.success("操作成功");
      this.dialogVisible = false
      this.getindexUserFun()
    },

  }
}
</script>

<style lang="scss" scoped>
  .plateorder{
    padding: 22px;
  }
  .plateorder-tabs{
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    padding: 9px 18px 8px 47px;
    .plateorder-tabs-input{
      .shaixuan_item {
        width: 350px;
        height: 54px;
        background: #ffffff;
        border-radius: 10px;
        padding: 0 20px;
        margin-right: 22px;
        .shaixuan_item_con {
          p {
            font-size: 18px;
          }
          .shaixuan_item_arr {
            width: 13px;
            height: 8px;
            margin-left: 10px;
          }
          .shaixuan_item_icon {
            width: 29px;
            height: 24px;
            margin-right: 10px;
          }
        }
      }

      .top_bar_inp {
        width: 372px;
        height: 54px;
        background: rgba(255, 255, 255, 1);
        border-radius: 10px;
        margin-right: 32px;
        padding: 0 11px;
        .top_bar_inp_img1 {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
        .top_bar_inp_inp {
          width: 282px;
          font-size: 17px;
          line-height: 17px;
        }
      }
    }
    .plateorder-tabs-piye-but{
      width: 138px;
      height: 55px;
      line-height: 53px;
      text-align: center;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid rgba(153, 153, 153, 1);
      font-size: 20px;
      margin-right: 26px;
    }
    .plateorder-tabs-input-but{
      width: 131px;
      height: 54px;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px;
      font-size: 20px;
      line-height: 54px;
      text-align: center
    }
  }

  .import-mask{
    width: 100%;
    border-radius: 15px;
    background-image: url('../../../../../assets/yimou/tb.png');
    background-size: 100% 51px;
    background-repeat: no-repeat;
    padding-bottom: 40px;
    .import-mask-title{
      width: 100%;
      height: 51px;
      line-height: 51px;
      text-align: center;
      font-size: 18px;
      img{
        width: 13px;
        height: 13px;
        top: 21px;
        right: 20px;
      }
    }
    .import-mask-boxs{
      width: 650px;
      margin-top: 40px;
      .import-mask-boxs-inp{
        width: 100%;
        background: rgba(245, 245, 245, 1); border-radius: 10px; padding: 11px 22px;
        margin-bottom: 19px;
        ul{
          li:nth-of-type(1){
            width: 185px;
            font-size: 18px;
            line-height: 18px;
            span{
              color: rgba(255, 0, 0, 1);
            }
          }
        }
      }
      .import-mask-boxs-inp .el-input /deep/.el-input__inner {
        border: none !important;
        background: none !important;
        font-size: 18px;
      }
      .import-mask-boxs-inp .el-textarea /deep/.el-textarea__inner{
        border: none !important;
        background: none !important;
        font-size: 18px;
      }

      .import-mask-boxs-upload{
        width: 100%; height: 168px;
        margin: 10px 0px 34px;
        background-image: url('../../../../../assets/yimou/hsk.png');
        img{
          width: 35px; height: 31px;
          margin-top: 39px;
        }
        .upload-title{
          font-size: 16px;
          line-height: 16px;
          margin: 16px 0px 13px;
          span:nth-of-type(2){
            color: rgba(20, 75, 201, 1);
          }
        }
        .upload-content{
          font-size: 14px;
          line-height: 14px;
        }
      }
      .import-mask-ul-boxs{
        width: 24vw;
      }
    }
    .import-mask-but{
      width: 266px;
      height: 47px;
      line-height: 47px;
      text-align: center;
      background: rgba(25, 92, 248, 1);
      border-radius: 10px;
      font-size: 17px;
    }
  }

  .plateorder-type{
    margin: 23px 0px;
    div{
      width: 155px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border-radius: 10px;
      margin-right: 14px
    }
    .active{
      color: rgba(255, 255, 255, 1);
      background: rgba(25, 92, 248, 1);
    }
    .activenot{
      color: rgba(35, 35, 35, 1);
      background: rgba(245, 245, 245, 1);
    }
  }

  .import-mask-boxs-inp .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
  }
  .revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
  }
  .el-select{
    width: 100% !important;
  }
  .el-select /deep/.el-input__inner{
    width: 100%;
    border: none !important;
    background: none !important;
    font-size: 18px;
  }
  .el-select /deep/.el-select__caret{
    color: #000000 !important;
  }
  .upload-demo /deep/.el-upload-dragger{
    background: none !important;
    border: none !important;
    border-radius: 0px !important;
    width: 640px !important;
    height: 168px;
  }

  .statusact{
    width: 13px;
    height: 13px;
    background: rgba(48, 255, 0, 1);
    border-radius: 50%;
    margin-right: 12px;
  }
  .statusactnot{
    width: 13px;
    height: 13px;
    background: red;
    border-radius: 50%;
    margin-right: 12px;
  }

  .reset-btn{
    font-size: 30px;
  }

  .revenbook-drawer{
    padding: 0px 25px;
    .revenbook-drawer-ul{
      margin-top: 27px;
      li:nth-of-type(1){
        font-size: 18px;
        margin-bottom: 20px;
        span{
          color: rgba(255, 17, 17, 1);
        }
        p{
          color: rgba(35, 35, 35, 1);
        }
      }
      .revenbook-drawer-ul-radio{
        margin-bottom: 18px;
      }
      .revenbook-drawer-ul-view{
        p{
          font-size: 18px;
          line-height: 18px;
          margin-right: 11px;
        }
        .revenbook-drawer-ul-boxs{
          background: rgba(245, 245, 245, 1); border-radius: 10px; padding: 10px;
          img{
            width: 22px; height: 22px; margin-right: 11px;
          }
          p{
            color: rgba(35, 35, 35, 1); font-size: 18px; line-height: 18px;
          }
        }
      }

      .revenbook-drawer-ul-u-tr{
        background: rgba(244, 245, 249, 1); padding: 14px 39px; margin-top: 24px; border-radius: 10px;
        p{
          font-size: 18px; line-height: 18px; width: 45%; margin-right: 20px;
        }
      }
      .revenbook-drawer-ul-u-th{
        padding: 14px 39px;
        p{
          font-size: 18px; line-height: 18px; width: 45%; margin-right: 20px;
        }
      }
      .revenbook-drawer-ul-but{
        width: 131px; height: 54px; line-height: 54px; text-align: center; background: rgba(25, 92, 248, 1); border-radius: 10px;
      }
    }
  }

  .shaixuan_item{
    .el-input /deep/.el-input__inner{
      border: none !important;
      text-align: right;
      font-size: 18px;
    }
    .el-input /deep/.el-input__prefix{
      display: none !important;
    }

    .el-select /deep/.el-input__inner{
      border: none !important;
      text-align: right;
      font-size: 18px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/main/level1/power_ment/personment/index.vue